import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '@helpers/app-routes';
import { AuthService } from '@services/auth.service';

/**
 * Autorise l'accès à la page scan soit avec une session agent classique,
 * soit avec le jeton réduit du mode pointeuse (posé après déconnexion de
 * l'agent) — contrairement à EnsureUserIsAuthenticated, utilisé partout
 * ailleurs, qui exige une session agent complète.
 */
export const ensureScanAccessGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.waitForInitialization();

  if (authService.isLogged() || authService.hasCheckInSession()) {
    return true;
  }

  void router.navigate([AppRoutes.login]);
  return false;
};
